<template>
  <!-- eslint-disable -->
  <div class="quiz-item">
    <va-tinymce-input
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.data.content"
      :editor-height="120"
      title="Content"
      :forced-root-block-attrs="{ class: 'quiz-destination' }"
      auto-resize
      @update="content => updateDestinationContent(content)" />
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: "QuizDestination",
    props: {
      node: {
        type: Object,
        required: true,
      },
      tree: {
        type: Object,
        required: true,
      },
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateDestinationContent(content) {
        this.node.data.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
